"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Correspond à Helium.DataTables.Enums.DatatableColumnTypeEnum
 */
var DatatableColumnTypeEnum;
(function (DatatableColumnTypeEnum) {
    DatatableColumnTypeEnum[DatatableColumnTypeEnum["string"] = 1] = "string";
    DatatableColumnTypeEnum[DatatableColumnTypeEnum["num"] = 2] = "num";
    DatatableColumnTypeEnum[DatatableColumnTypeEnum["date"] = 3] = "date";
    DatatableColumnTypeEnum[DatatableColumnTypeEnum["select"] = 4] = "select";
})(DatatableColumnTypeEnum = exports.DatatableColumnTypeEnum || (exports.DatatableColumnTypeEnum = {}));
/**
 * Correspond à Helium.DataTables.Enums.export enum DatatableSelectTypeEnum
 */
var DatatableSelectTypeEnum;
(function (DatatableSelectTypeEnum) {
    DatatableSelectTypeEnum[DatatableSelectTypeEnum["select2"] = 1] = "select2";
    DatatableSelectTypeEnum[DatatableSelectTypeEnum["custom_select"] = 2] = "custom_select";
})(DatatableSelectTypeEnum = exports.DatatableSelectTypeEnum || (exports.DatatableSelectTypeEnum = {}));
/**
 * Correspond à Helium.DataTables.Request.DatatableRequestSearchOperator
 */
var DatatableRequestSearchOperator;
(function (DatatableRequestSearchOperator) {
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["egal"] = 0] = "egal";
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["sup"] = 1] = "sup";
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["sup_egal"] = 2] = "sup_egal";
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["inf"] = 3] = "inf";
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["inf_egal"] = 4] = "inf_egal";
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["diff"] = 5] = "diff";
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["in"] = 6] = "in";
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["starts_with"] = 7] = "starts_with";
    DatatableRequestSearchOperator[DatatableRequestSearchOperator["ends_with"] = 8] = "ends_with";
})(DatatableRequestSearchOperator = exports.DatatableRequestSearchOperator || (exports.DatatableRequestSearchOperator = {}));
/**
 * Metadata de @see DatatableRequestSearchOperator
 */
exports.DatatableRequestSearchOperatorMetadata = [{ id: DatatableRequestSearchOperator.egal, name: "=", description: "Egal" }, {
    id: DatatableRequestSearchOperator.sup,
    name: ">",
    description: "Supérieur"
}, {
    id: DatatableRequestSearchOperator.sup_egal,
    name: ">=",
    description: "Supérieur ou égal"
}, {
    id: DatatableRequestSearchOperator.inf,
    name: "<",
    description: "Inférieur"
}, {
    id: DatatableRequestSearchOperator.inf_egal,
    name: "<=",
    description: "Inférieur ou Egal"
}, {
    id: DatatableRequestSearchOperator.diff,
    name: "!=",
    description: "Différent de"
}, {
    id: DatatableRequestSearchOperator.in,
    name: "Contient",
    description: "Contient"
}, {
    id: DatatableRequestSearchOperator.starts_with,
    name: "Commence par",
    description: "Commence par"
}, {
    id: DatatableRequestSearchOperator.ends_with,
    name: "Finit par",
    description: "Finit par"
}];


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/SharedComponent/HeDatatable/models.ts
// module id = 226
// module chunks = 0